<template>
  <a-spin :spinning="spinning">
    <a-card>
      <div class="search">
        <a-form layout="horizontal" :model="form">
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="发货地" :labelCol="{ span: 4 }" :wrapperCol="{ span: 15 }">
                <a-select show-search placeholder="请选择" v-model="form.sendAddr" option-filter-prop="children"
                  style="width: 100%" :filter-option="filterOption" @change="handleSendAddrChange">
                  <a-select-option v-for="(item, index) in sendList" :key="index" :value="item.name">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="收货地" :labelCol="{ span: 6 }" :wrapperCol="{ span: 15 }">
                <a-select show-search placeholder="请输入" v-model="form.receiveAddr" option-filter-prop="children"
                  style="width: 100%" :filter-option="filterOption" @change="handleReceiveAddrChange">
                  <a-select-option v-for="(item, index) in receiveList" :key="index" :value="item.name">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="品名" :labelCol="{ span: 6 }" :wrapperCol="{ span: 15 }">
                <a-select show-search placeholder="请输入" v-model="form.goodsName" option-filter-prop="children"
                  style="width: 100%" :filter-option="filterOption" @change="handleGoodsNameChange">
                  <a-select-option v-for="(item, index) in goodsNameList" :key="index" :value="item.name">
                    {{ item.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="发货日期" :labelCol="{ span: 4 }" :wrapperCol="{ span: 15 }">
                <a-range-picker v-model="form.deliverDate" format="YYYY-MM-DD" @change="changeDate" :locale="locale" />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-button type="primary" @click="search(1)">查询</a-button>
              <div class="space"></div>
              <a-button type="default" @click="reset()">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table">
        <div class="add">
          <a-button type="primary" @click="handleAdd" v-if="isAddShow">
            <a-icon type="plus" />新增</a-button>
          <a-button style="margin-left: 10px" type="default" @click="export2Excel">
            导出excel</a-button>
        </div>
        <standard-table :columns="columns" :dataSource="listData" :pagination="pagination" @change="onChange"
          :loading="loading" :scroll="{ x: 2100 }">
          <div slot="status" slot-scope="{ record }">
            <span>
              {{
                record.status == "0"
                ? "审核中"
                : record.status == "1"
                  ? "审核通过"
                  : record.status == "2"
                    ? "审核拒绝"
                    : "--"
              }}</span>
          </div>
          <div slot="operate" slot-scope="record">
            <a-popconfirm ok-text="是" cancel-text="否" @confirm="popConfirm(record)" @cancel="popCancel"
              :disabled="record.record.status !== 0">
              <template slot="title">
                <div>操作审核？</div>
                <div class="popRadio">
                  <a-radio-group name="radioGroup" v-model="popValue">
                    <a-radio :value="1"> 审核通过 </a-radio>
                    <a-radio :value="2"> 审核拒绝 </a-radio>
                  </a-radio-group>
                </div>
              </template>
              <a-button size="small" type="danger" v-show="level <= 3" :disabled="record.record.status !== 0"
                @click.prevent="examine(record)">
                审核
              </a-button>
            </a-popconfirm>
            &nbsp;&nbsp;
            <a @click="handleReceiveUpdate(record)">修改</a>&nbsp;
            <a @click="handleReceiveDelete(record)"> 删除 </a>&nbsp;
          </div>
          <div slot="enclosure" slot-scope="record">
            <a @click="handleVoucher(record)" :disabled="!record.record.applyVoucherUrl.includes('https')">凭证</a>
          </div>
        </standard-table>
      </div>
      <div class="voucher" v-show="applyVoucherUrlVisible">
        <a-modal class="voucher" v-model="applyVoucherUrlVisible" title="凭证" cancelText="关闭" :key="key" width="60%">
          <standard-table :columns="columns2" :dataSource="applyVoucherList" :pagination="pagination2" @change="onChange2"
            :selectedRows.sync="selectedRows" @selectedRowChange="selectedRowChange">
            <div slot="voucherUrl" slot-scope="record">
              <viewer class="imgs">
                <img :src="record.record.voucherUrl" width="100%" height="100%">
              </viewer>
            </div>
            <div slot="operate" slot-scope="record">
              <a :href="record.record.voucherUrl">下载</a>
              &nbsp;&nbsp;
              <a href="javascript:void(0);" @click="handleDeleteImg(record.record)">删除</a>
            </div>
            <template v-slot:bottomLeft>
              <a-button class="download-btn" @click="batchDownload" v-show="downLoadShow"> <a-icon type="download" /> 批量下载
              </a-button>
              <a-button class="delete-btn" @click="batchDelete" v-show="downLoadShow"> <a-icon type="delete" /> 批量删除
              </a-button>
            </template>
            <template v-slot:bottomRight>
              <div class="preview-box" :class="!downLoadShow ? 'init-preview-box' : ''" v-if="initImageUrls.length > 1">
                <a-button class="preview-btn" @click="handlePreview"> {{ previewBtnText }} </a-button>
                <viewer :images="initImageUrls" class="imgs-batch-preview" v-show="batchPreviewViewerShow">
                  <img v-for="(url, index) in initImageUrls" :key="index" :src="url">
                </viewer>
              </div>

            </template>
          </standard-table>
        </a-modal>
      </div>

      <div class="modal" v-show="visible">
        <a-modal v-model="visible" :title="modalTitle" @ok="handleOk"  :confirmLoading="confirmLoading" cancelText="取消" okText="保存" :key="key" width="60%">
          <a-spin :spinning="spinning2">
            <a-form-model ref="addForm" :model="addForm" v-bind="layout">
              <div class="modelItem">
                <a-form-model-item has-feedback label="发货人">
                  <a-input v-model.trim="addForm.deliverer" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="发货日期">
                  <a-date-picker v-model="addForm.deliverDate" format="YYYY-MM-DD" @change="changeDate2"
                    :locale="locale" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="车牌号">
                  <a-input v-model.trim="addForm.licenseNum" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="品名">
                  <a-select show-search placeholder="请输入" v-model="addForm.goodsName" option-filter-prop="children"
                    style="width: 100%" :filter-option="filterOption" @change="handleGoodsNameChange2">
                    <a-select-option v-for="(item, index) in goodsNameList" :key="index" :value="item.name">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item label="发货地">
                  <a-select show-search placeholder="请输入" v-model="addForm.sendAddr" option-filter-prop="children"
                    style="width: 100%" :filter-option="filterOption" @change="handleSendAddrChange2">
                    <a-select-option v-for="(item, index) in sendList" :key="index" :value="item.name">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item has-feedback label="收货地">
                  <a-select show-search placeholder="请输入" v-model="addForm.receiveAddr" option-filter-prop="children"
                    style="width: 100%" :filter-option="filterOption" @change="handleReceiveAddrChange2">
                    <a-select-option v-for="(item, index) in receiveList" :key="index" :value="item.name">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item has-feedback label="采购单价">
                  <a-input v-model.trim="addForm.purchaseUnitPrice" @blur="handlePurchaseUnitPrice" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="收货重量（吨）">
                  <a-input v-model.trim="addForm.receiveGoodsWeight" @blur="handleReceiveGoodsWeight" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="采购金额">
                  <a-input v-model.trim="addForm.purchaseMoney" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="出货重量（吨）">
                  <a-input v-model.trim="addForm.sendGoodsWeight" @blur="handleWeight('sendGoodsWeight')" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="加油(升)">
                  <a-input v-model.trim="addForm.oil" @blur="handleWeight('oil')" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="司机领款金额">
                  <a-input v-model.trim="addForm.driverReceiveMoney" @blur="handlePrice('driverReceiveMoney')" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="司机收运费款">
                  <a-input v-model.trim="addForm.freightPayment" @blur="handlePrice('freightPayment')" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="司机报销金额">
                  <a-input v-model.trim="addForm.applyMoney" @blur="handlePrice('applyMoney')" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="司机领款事由">
                  <a-input v-model.trim="addForm.driverReceiveDesc" />
                </a-form-model-item>
                <a-form-model-item has-feedback label="司机领款付款方式">
                  <a-select v-model="addForm.driverReceiveType">
                    <a-select-option value="微信">微信</a-select-option>
                    <a-select-option value="支付宝">支付宝</a-select-option>
                    <a-select-option value="银联">银联</a-select-option>
                    <a-select-option value="现金">现金</a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item has-feedback label="司机报销事由">
                  <a-input v-model.trim="addForm.applyMoneyDesc" />
                </a-form-model-item>

                <a-form-model-item has-feedback label="报销凭证">
                  <!-- <a-input v-model="addForm.applyVoucherUrl" /> -->
                  <a-upload name="file" :multiple="true" :customRequest="customRequest" :loading="uploading"
                    :handleChange="handleChange" size="500px">
                    <a-button> <a-icon type="upload" /> 上传凭证 </a-button>
                  </a-upload>
                </a-form-model-item>
              </div>
            </a-form-model>
          </a-spin>
        </a-modal>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import StandardTable from "@/components/StandardTable";
import moment from "moment";
import {
  driverbookList,
  driverbookSave,
  driverbookUpdate,
  driverbookDelete,
  driverbookExamine,
} from "@/api/modules/standingBookManagement.js";
import axios from "axios";
import { goodsNameAll, receiveAll, sendAll } from "@/api/api.js";
export default {
  name: "transportationAccountManagement",
  data() {
    return {
      locale,
      form: {
        sendAddr: "",
        receiveAddr: "",
        goodsName: "",
        deliverDate: [],
        start: "",
        end: "",
      },
      isAddShow: true,
      goodsNameList: null,
      receiveList: null,
      sendList: null,
      applyVoucherList: [],
      listDataExcel: [],
      popValue: 1,
      addForm: {
        deliverer: "",
        deliverDate: "",
        licenseNum: "",
        sendAddr: "",
        receiveAddr: "",
        goodsName: "",
        sendGoodsWeight: "", //出货重量（吨）
        receiveGoodsWeight: "", //收货重量（吨）
        purchaseUnitPrice: "", //采购单价
        purchaseMoney: "", //采购金额
        freightPayment: "", //司机收运费款
        oil: "", //加油(升)
        driverReceiveMoney: "", //司机领款金额
        driverReceiveDesc: "",
        driverReceiveType: "",
        applyMoney: "", //司机报销金额
        applyMoneyDesc: "",
        applyVoucherUrl: "",
      },
      applyVoucherUrlArr: [],
      headers: {
        "Content-Type": "multipart/form-data",
        Token: sessionStorage.getItem("Token") || localStorage.getItem("Token"),
      },
      pagination: {
        total: 0,
        pageSize: 10, //每页中显示10条数据
        current: 1,
        showTotal: (total) => `共 ${total} 条`, //分页中显示总的数据
      },
      pagination2: {
        total: 0,
        pageSize: 10, //每页中显示10条数据
        current: 1,
        showTotal: (total) => `共 ${total} 条`, //分页中显示总的数据
      },
      layout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 12 },
      },
      columns: [
        {
          title: "发货人",
          dataIndex: "deliverer",
          align: "center",
        },
        {
          title: "车牌号",
          dataIndex: "licenseNum",
          align: "center",
        },
        {
          title: "发货日期",
          dataIndex: "deliverDate",
          align: "center",
          width: "120px",
        },
        {
          title: "发货地",
          dataIndex: "sendAddr",
          align: "center",
        },
        {
          title: "收货地",
          dataIndex: "receiveAddr",
          align: "center",
        },
        {
          title: "品名",
          dataIndex: "goodsName",
          align: "center",
        },
        {
          title: "出货重量（吨）",
          dataIndex: "sendGoodsWeight",
          align: "center",
        },
        {
          title: "收货重量（吨）",
          dataIndex: "receiveGoodsWeight",
          align: "center",
        },
        {
          title: "采购单价",
          dataIndex: "purchaseUnitPrice",
          align: "center",
        },
        {
          title: "采购金额",
          dataIndex: "purchaseMoney",
          align: "center",
        },
        {
          title: "司机收运费款",
          dataIndex: "freightPayment",
          align: "center",
        },
        {
          title: "加油",
          dataIndex: "oil",
          align: "center",
        },
        {
          title: "司机领款金额",
          dataIndex: "driverReceiveMoney",
          align: "center",
        },
        {
          title: "司机领款事由",
          dataIndex: "driverReceiveDesc",
          align: "center",
        },
        {
          title: "司机领款付款方式",
          dataIndex: "driverReceiveType",
          align: "center",
        },
        {
          title: "司机报销金额",
          dataIndex: "applyMoney",
          align: "center",
        },
        {
          title: "司机报销事由",
          dataIndex: "applyMoneyDesc",
          align: "center",
        },
        {
          title: "状态",
          dataIndex: "status",
          align: "center",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "创建时间",
          dataIndex: "createTime",
          align: "center",
          width: "180px",
        },
        {
          title: "操作",
          dataIndex: "operate",
          align: "center",
          scopedSlots: { customRender: "operate" },
          fixed: "right",
        },
        {
          title: "附件",
          dataIndex: "enclosure",
          align: "center",
          scopedSlots: { customRender: "enclosure" },
          fixed: "right",
        },
      ],
      columns2: [
        {
          title: "文件类型",
          dataIndex: "voucherType",
          align: "center",
        },
        {
          title: "图片预览",
          dataIndex: "voucherUrl",
          align: "center",
          scopedSlots: { customRender: "voucherUrl" }
        },
        {
          title: "附件名称",
          dataIndex: "voucherName",
          align: "center",
        },
        {
          title: "操作",
          dataIndex: "operate",
          align: "center",
          scopedSlots: { customRender: "operate" },
          fixed: "right",
        },
      ],
      listData: null,
      spinning: false,
      uploading: false,
      spinning2: false,
      loading: false,
      visible: false,
      applyVoucherUrlVisible: false,
      level: "",
      key: "",
      modalTitle: "",
      initImageUrls: [],
      selectedRows: [],
      imageUrls: [],
      downLoadShow: false,
      batchPreviewViewerShow: false,
      previewBtnText: '批量预览',
      deleteImgUpdateInfo: null,
      confirmLoading:false
    };
  },
  created() {
    let date = new Date();
    let year = date.getFullYear();
    let month = String(date.getMonth() + 1).padStart(2, "0");
    let day = String(date.getDate()).padStart(2, "0");
    this.form.deliverDate = [`${year}-${month}-1`, `${year}-${month}-${day}`];
    (this.form.start = `${year}-${month}-1`),
      (this.form.end = `${year}-${month}-${day}`);
    this.search(1);
    this.level = JSON.parse(sessionStorage.getItem("userInfo")).level;
    this.getReceiveSearch();
    this.getSendSearch();
    this.getGoodsNameSearch();
    this.init();
  },
  components: {
    StandardTable,
  },
  watch: {
    imageUrls() {
      if (this.imageUrls.length > 0) {
        this.downLoadShow = true
      } else {
        this.downLoadShow = false
      }
    }
  },
  methods: {
    moment,
    init() {
      let menuList = this.$store.state.menuList;
      if (menuList[0].subMenus[0].subMenus[1].name.includes("审核")) {
        this.isAddShow = false;
      }
    },
    //查询发货地
    getSendSearch() {
      sendAll("", 1).then((res) => {
        if (res.code == "0000") {
          this.sendList = res.data;
        }
      });
    },
    //查询收货地
    getReceiveSearch() {
      receiveAll("", 2).then((res) => {
        if (res.code == "0000") {
          this.receiveList = res.data;
        }
      });
    },
    //查询品名
    getGoodsNameSearch() {
      goodsNameAll("", 3).then((res) => {
        if (res.code == "0000") {
          this.goodsNameList = res.data;
        }
      });
    },
    handleGoodsNameChange(value) {
      this.form.goodsName = value;
    },
    handleGoodsNameChange2(value) {
      this.addForm.goodsName = value;
    },
    handleSendAddrChange(value) {
      this.form.sendAddr = value;
    },
    handleSendAddrChange2(value) {
      this.addForm.sendAddr = value;
    },
    handleReceiveAddrChange(value) {
      this.form.receiveAddr = value;
    },
    handleReceiveAddrChange2(value) {
      this.addForm.receiveAddr = value;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    //查询用户列表
    search(val) {
      this.pagination.current = val;
      let params = {
        sendAddr: this.form.sendAddr,
        receiveAddr: this.form.receiveAddr,
        goodsName: this.form.goodsName,
        deliverDate: "",
      };
      this.loading = true;
      driverbookList(
        params,
        val,
        this.pagination.pageSize,
        this.form.start,
        this.form.end
      ).then((res) => {
        if (res.code == "0000") {
          this.listData = res.data.list.map((item) => {
            for (let key in item) {
              if (item[key] === null || item[key] === "") {
                item[key] = "--";
              }
              if (
                [
                  "purchaseUnitPrice",
                  "purchaseMoney",
                  "freightPayment",
                  "driverReceiveMoney",
                  "applyMoney",
                ].some((ele) => ele === key)
              ) {
                item[key] = this.returnFloat(
                  Number(item[key]).toLocaleString(),
                  "price"
                );
              }
              if (
                ["sendGoodsWeight", "receiveGoodsWeight", "oil"].some(
                  (ele) => ele === key
                )
              ) {
                item[key] = this.returnFloat(item[key], "weight");
              }
            }
            return item;
          });
          this.pagination.total = res.data.totalCount;
        } else {
          this.$message.warn(res.msg);
        }
        this.loading = false;
      });
    },
    reset() {
      let date = new Date();
      let year = date.getFullYear();
      let month = String(date.getMonth() + 1).padStart(2, "0");
      let day = String(date.getDate()).padStart(2, "0");
      this.form = {
        sendAddr: "",
        receiveAddr: "",
        goodsName: "",
        deliverDate: [`${year}-${month}-1`, `${year}-${month}-${day}`],
        start: `${year}-${month}-1`,
        end: `${year}-${month}-${day}`,
      };
    },
    //选择日期
    changeDate(val) {
      // if (val == null || val == undefined || val == "") {
      //   return (this.form.deliverDate = "");
      // }
      this.form.start = this.$moment(val[0]).format("YYYY-MM-DD");
      this.form.end = this.$moment(val[1]).format("YYYY-MM-DD");
    },
    changeDate2(val) {
      if (val == null || val == undefined || val == "") {
        return (this.addForm.deliverDate = "");
      }
      this.addForm.deliverDate = this.$moment(val).format("YYYY-MM-DD");
    },
    onChange(val) {
      this.pagination.current = val.current;
      this.search(this.pagination.current);
    },
    onChange2(val) {
      this.pagination2.current = val.current;
    },
    customRequest(options) {
      console.log("1111", options);
      let params = new FormData();
      params.append("file", options.file);
      //添加请求头
      let _this = this;
      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
          Token:
            sessionStorage.getItem("Token") || localStorage.getItem("Token"),
        },
      };
      this.uploading = true;
      this.confirmLoading = true
      axios
        .post(
          `${process.env.VUE_APP_REQUEST_URL}/upload/voucher`,
          params,
          config
        )
        .then((res) => {
          this.confirmLoading = false
          if (res.data.code == "0000") {
            this.$message.success("上传成功");
            this.applyVoucherUrlArr.push(res.data.data);
            console.log("上传的所有图片",this.applyVoucherUrlArr)
          } else {
            return this.$message.warn(res.data.msg);
          }
          options.onSuccess(res, options.file);
        })
        .catch((err) => {
          return Promise.reject(err);
        });
    },
    handleChange(info) {
      if (info.file.status === "uploading") {
        this.uploading = true;
        this.confirmLoading = true
        return;
      }
      if (info.file.status === "done") {
        this.uploading = false;
        this.confirmLoading = false
      }
    },
    handleAdd() {
      this.key++;
      this.modalTitle = "新增";
      this.applyVoucherUrlArr = []
      for (let key in this.addForm) {
        if (this.addForm[key] !== "") {
          this.addForm[key] = "";
        }
      }
      this.addForm.deliverDate = this.$moment(new Date()).format("YYYY-MM-DD");
      this.visible = true;
    },
    handleOk() {
      if (!this.addForm.goodsName) {
        return this.$message.warn("请选择品名")
      }
      if (!this.addForm.sendAddr) {
        return this.$message.warn("请选择发货地址")
      }
      if (!this.addForm.receiveAddr) {
        return this.$message.warn("请选择收货地址")
      }
      if (this.modalTitle == "新增") {
        let params = Object.assign(this.addForm);
        if (this.applyVoucherUrlArr.length > 1) {
          params.applyVoucherUrl = this.applyVoucherUrlArr.join(",");
        } else {
          params.applyVoucherUrl = this.applyVoucherUrlArr[0];
        }
        (params.sendGoodsWeight = Number(this.addForm.sendGoodsWeight)), //出货重量（吨）
          (params.receiveGoodsWeight = Number(this.addForm.receiveGoodsWeight)), //收货重量（吨）
          (params.purchaseUnitPrice =
            String(this.addForm.purchaseUnitPrice).indexOf(",") !== -1
              ? Number(this.addForm.purchaseUnitPrice.replace(/,/g, ""))
              : Number(this.addForm.purchaseUnitPrice)), //采购单价
          (params.purchaseMoney =
            String(this.addForm.purchaseMoney).indexOf(",") !== -1
              ? Number(this.addForm.purchaseMoney.replace(/,/g, ""))
              : Number(this.addForm.purchaseMoney)), //采购金额
          (params.freightPayment =
            String(this.addForm.freightPayment).indexOf(",") !== -1
              ? Number(this.addForm.freightPayment.replace(/,/g, ""))
              : Number(this.addForm.freightPayment)), //司机收运费款
          (params.oil = Number(this.addForm.oil)), //加油(升)
          (params.driverReceiveMoney =
            String(this.addForm.driverReceiveMoney).indexOf(",") !== -1
              ? Number(this.addForm.driverReceiveMoney.replace(/,/g, ""))
              : Number(this.addForm.driverReceiveMoney)), //司机领款金额applyMoney
          (params.applyMoney =
            String(this.addForm.applyMoney).indexOf(",") !== -1
              ? Number(this.addForm.applyMoney.replace(/,/g, ""))
              : Number(this.addForm.applyMoney));
        this.spinning2 = true;
        driverbookSave("", params).then((res) => {
          this.spinning2 = false;
          if (res.code == "0000") {
            this.$message.success(res.msg);
            this.search(1);
            this.visible = false;
          } else {
            this.$message.warn(res.msg);
          }
        });
      } else if (this.modalTitle == "修改") {
        let params = Object.assign(this.addForm);
        if (this.applyVoucherUrlArr.length > 1) {
          params.applyVoucherUrl = this.applyVoucherUrlArr.join(",");
        } else {
          params.applyVoucherUrl = this.applyVoucherUrlArr[0];
        }
        (params.sendGoodsWeight = Number(this.addForm.sendGoodsWeight)), //出货重量（吨）
          (params.receiveGoodsWeight = Number(this.addForm.receiveGoodsWeight)), //收货重量（吨）
          (params.purchaseUnitPrice =
            String(this.addForm.purchaseUnitPrice).indexOf(",") !== -1
              ? Number(this.addForm.purchaseUnitPrice.replace(/,/g, ""))
              : Number(this.addForm.purchaseUnitPrice)), //采购单价
          (params.purchaseMoney =
            String(this.addForm.purchaseMoney).indexOf(",") !== -1
              ? Number(this.addForm.purchaseMoney.replace(/,/g, ""))
              : Number(this.addForm.purchaseMoney)), //采购金额
          (params.freightPayment =
            String(this.addForm.freightPayment).indexOf(",") !== -1
              ? Number(this.addForm.freightPayment.replace(/,/g, ""))
              : Number(this.addForm.freightPayment)), //司机收运费款
          (params.oil = Number(this.addForm.oil)), //加油(升)
          (params.driverReceiveMoney =
            String(this.addForm.driverReceiveMoney).indexOf(",") !== -1
              ? Number(this.addForm.driverReceiveMoney.replace(/,/g, ""))
              : Number(this.addForm.driverReceiveMoney)), //司机领款金额applyMoney
          (params.applyMoney =
            String(this.addForm.applyMoney).indexOf(",") !== -1
              ? Number(this.addForm.applyMoney.replace(/,/g, ""))
              : Number(this.addForm.applyMoney));
        if (params.applyVoucherUrl == undefined) {
          params.applyVoucherUrl = ''
        }
        this.spinning2 = true;
        driverbookUpdate("", params).then((res) => {
          this.spinning2 = false;
          if (res.code == "0000") {
            this.$message.success(res.msg);
            this.search(this.pagination.current);
            this.visible = false;
          } else {
            this.$message.warn(res.msg);
          }
        });
      }
    },
    examine(record) {
      if (record.record.status !== 0) {
        return false;
      }
    },
    //查看凭证
    handleVoucher(record) {
      this.deleteImgUpdateInfo = Object.assign(record.record)
      this.applyVoucherList = [];
      this.applyVoucherUrlVisible = true

      this.selectedRows = [],
        this.initImageUrls = []
      this.imageUrls = [],
        this.downLoadShow = false,
        this.batchPreviewViewerShow = false
      this.previewBtnText = "批量预览"

      let applyVoucherUrlArr = record.record.applyVoucherUrl.split(",");
      this.pagination2.total = applyVoucherUrlArr.length;
      applyVoucherUrlArr.forEach((ele) => {
        let voucherArr = ele.split("/");
        let Obj = {
          voucherType: "其他",
          voucherName: voucherArr[voucherArr.length - 1],
          voucherUrl: ele,
        };
        this.applyVoucherList.push(Obj);
        this.initImageUrls.push(ele)

      });

    },
    handleReceiveUpdate(record) {
      let urrArr = record.record.applyVoucherUrl.split(',').filter(item => item.indexOf("http") !== -1)
      this.key++;
      this.modalTitle = "修改";
      this.applyVoucherUrlArr = [...urrArr]
      this.addForm = Object.assign(record.record);
      this.visible = true;
    },
    handleReceiveDelete(record) {
      if (record.record.status == 0) {
        return this.$message.warn("正在审核中，无法删除");
      } else {
        let that = this;
        this.$confirm({
          title: "操作提示",
          content: "是否删除该记录信息？",
          okText: "确定",
          cancelText: "取消",
          onOk() {
            let id = record.record.id;
            that.loading = true;
            driverbookDelete(id).then((res) => {
              if (res.code == "0000") {
                if(that.pagination.total % 10 == 1 && that.pagination.current > 1){
                  that.search(that.pagination.current - 1);
                }else{
                  that.search(that.pagination.current);
                }
               
                that.$message.success(res.msg);
              } else {
                that.$message.warn(res.msg);
              }
              that.loading = false;
            });
          },
        });
      }
    },
    popConfirm(record) {
      console.log(record);
      let params = {
        id: record.record.id,
        status: this.popValue,
      };
      this.spinning = true;
      driverbookExamine("", params).then((res) => {
        this.spinning = false;
        if (res.code == "0000") {
          this.$message.success("操作成功");
        }
        this.search(this.pagination.current);
        this.popValue = 1;
        console.log(res);
      });
    },
    handleReceiveGoodsWeight() {
      if (
        /^([^0]{0,1}[0-9]*[.]{0,1}[0-9]+)$/.test(
          this.addForm.receiveGoodsWeight
        )
      ) {
        if (this.addForm.receiveGoodsWeight.charAt(0) === ".") {
          this.addForm.receiveGoodsWeight =
            "0" + this.addForm.receiveGoodsWeight;
        }
        if (this.addForm.receiveGoodsWeight.indexOf(".") !== -1) {
          if (this.addForm.receiveGoodsWeight.split(".")[0].length > 12) {
            this.addForm.receiveGoodsWeight = "";
            return this.$message.warn("整数位最大长度为12！");
          }
          if (this.addForm.receiveGoodsWeight.split(".")[1].length > 2) {
            this.addForm.receiveGoodsWeight = Number(
              this.addForm.receiveGoodsWeight
            ).toFixed(2);
          }
        }
        this.addForm.receiveGoodsWeight = this.returnFloat(
          this.addForm.receiveGoodsWeight,
          "weight"
        );
        // this.handlePurchaseMoney(
        //   this.addForm.receiveGoodsWeight,
        //   this.addForm.purchaseUnitPrice
        // );
      } else {
        this.addForm.receiveGoodsWeight = "";
        return this.$message.warn("重量输入格式有误，请重新输入！");
      }
    },
    handlePurchaseUnitPrice() {
      // this.handleMoney(this.addForm.weight, this.addForm.unitPrice);
      if (
        /^([^0]{0,1}[0-9]*[.]{0,1}[0-9]+)$/.test(this.addForm.purchaseUnitPrice)
      ) {
        if (this.addForm.purchaseUnitPrice.indexOf(".") !== -1) {
          if (this.addForm.purchaseUnitPrice.split(".")[0].length > 12) {
            this.addForm.purchaseUnitPrice = "";
            return this.$message.warn("整数位最大长度为12！");
          }
          if (this.addForm.purchaseUnitPrice.split(".")[1].length > 2) {
            this.addForm.purchaseUnitPrice = Number(
              this.addForm.purchaseUnitPrice
            ).toFixed(3);
          }
        }
        this.addForm.purchaseUnitPrice = this.returnFloat(
          Number(this.addForm.purchaseUnitPrice).toLocaleString(),
          "price"
        );
        // this.handlePurchaseMoney(
        //   this.addForm.receiveGoodsWeight,
        //   this.addForm.purchaseUnitPrice
        // );
      } else {
        this.addForm.purchaseUnitPrice = "";
        return this.$message.warn("金额输入格式有误，请重新输入！");
      }
    },
    handlePurchaseMoney(weight, unitPrice) {
      if (weight === "" || unitPrice === "") {
        this.addForm.purchaseMoney = "";
      } else {
        let weight = Number(this.addForm.receiveGoodsWeight);
        let unitPrice =
          this.addForm.purchaseUnitPrice.indexOf(",") !== -1
            ? Number(this.addForm.purchaseUnitPrice.replace(/,/g, ""))
            : Number(this.addForm.purchaseUnitPrice);
        this.addForm.purchaseMoney = this.returnFloat(
          Number(weight * unitPrice).toLocaleString(),
          "price"
        );
      }
    },
    handleWeight(key) {
      if (/^([^0]{0,1}[0-9]*[.]{0,1}[0-9]+)$/.test(this.addForm[key])) {
        if (this.addForm[key].charAt(0) === ".") {
          this.addForm[key] = "0" + this.addForm[key];
        }
        if (this.addForm[key].indexOf(".") !== -1) {
          if (this.addForm[key].split(".")[0].length > 12) {
            this.addForm[key] = "";
            return this.$message.warn("整数位最大长度为12！");
          }
          if (this.addForm[key].split(".")[1].length > 2) {
            this.addForm[key] = Number(this.addForm[key]).toFixed(2);
          }
        }
        this.addForm[key] = this.returnFloat(this.addForm[key], "weight");
      } else {
        this.addForm[key] = "";
        return this.$message.warn("重量输入格式有误，请重新输入！");
      }
    },
    handlePrice(key) {
      // this.handleMoney(this.addForm.weight, this.addForm.unitPrice);
      if (/^([^0]{0,1}[0-9]*[.]{0,1}[0-9]+)$/.test(this.addForm[key])) {
        if (this.addForm[key].indexOf(".") !== -1) {
          if (this.addForm[key].split(".")[0].length > 12) {
            this.addForm[key] = "";
            return this.$message.warn("整数位最大长度为12！");
          }
          if (this.addForm[key].split(".")[1].length > 2) {
            this.addForm[key] = Number(this.addForm[key]).toFixed(3);
          }
        }
        this.addForm[key] = this.returnFloat(
          Number(this.addForm[key]).toLocaleString(),
          "price"
        );
      } else {
        this.addForm[key] = "";
        return this.$message.warn("金额输入格式有误，请重新输入！");
      }
    },
    //金额或数量小数点不足两位自动补零
    returnFloat(value, flag) {
      var s = value.toString().split(".");
      if (s.length == 1 && flag == "price") {
        value = value.toString() + ".000";
        return value;
      } else if (s.length == 1 && flag == "weight") {
        value = value.toString() + ".00";
        return value;
      }
      if (s.length > 1 && flag == "price") {
        if (s[1].length == 1) {
          value = value.toString() + "00";
        }
        if (s[1].length == 2 && flag == "price") {
          value = value.toString() + "0";
        }
        return value;
      } else if (s.length > 0 && flag == "weight") {
        if (s[1].length == 1) {
          value = value.toString() + "0";
        }
        return value;
      }
    },
    async export2Excel() {
      let params = {
        sendAddr: this.form.sendAddr,
        receiveAddr: this.form.receiveAddr,
        goodsName: this.form.goodsName,
        deliverDate: "",
      };
      await driverbookList(
        params,
        1,
        this.pagination.total,
        this.form.start,
        this.form.end
      ).then((res) => {
        if (res.code == "0000") {
          this.listDataExcel = res.data.list.map((item) => {
            item.status =
              item.status == "0"
                ? "审核中"
                : item.status == "1"
                  ? "审核通过"
                  : item.status == "2"
                    ? "审核拒绝"
                    : "--";
            for (let key in item) {
              if (item[key] === null || item[key] === "") {
                item[key] = "--";
              }
              if (
                [
                  "purchaseUnitPrice",
                  "purchaseMoney",
                  "freightPayment",
                  "driverReceiveMoney",
                  "applyMoney",
                ].some((ele) => ele === key)
              ) {
                item[key] = this.returnFloat(
                  Number(item[key]).toLocaleString(),
                  "price"
                );
              }
              if (
                ["sendGoodsWeight", "receiveGoodsWeight", "oil"].some(
                  (ele) => ele === key
                )
              ) {
                item[key] = this.returnFloat(item[key], "weight");
              }
            }
            return item;
          });
        } else {
          this.$message.warn(res.msg);
        }
      });

      require.ensure([], () => {
        const { export_json_to_excel } = require("../../excel/Export2Excel");
        const tHeader = [
          "发货人",
          "车牌号",
          "发货日期",
          "发货地",
          "收货地",
          "品名",
          "出货重量（吨）",
          "收货重量（吨）",
          "采购单价",
          "采购金额",
          "司机收运费款",
          "加油",
          "司机领款金额",
          "司机领款事由",
          "司机领款付款方式",
          "司机报销金额",
          "司机报销事由",
          "状态",
          "创建时间",
        ];
        const filterVal = [
          "deliverer",
          "licenseNum",
          "deliverDate",
          "sendAddr",
          "receiveAddr",
          "goodsName",
          "sendGoodsWeight",
          "receiveGoodsWeight",
          "purchaseUnitPrice",
          "purchaseMoney",
          "freightPayment",
          "oil",
          "driverReceiveMoney",
          "driverReceiveDesc",
          "driverReceiveType",
          "applyMoney",
          "applyMoneyDesc",
          "status",
          "createTime",
        ];
        const data = this.formatJson(filterVal, this.listDataExcel);
        export_json_to_excel(tHeader, data, "司机运输表");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    popCancel() { },
    selectedRowChange(selectedRowKeys, selectedRows) {
      console.log("选中的行", selectedRowKeys, selectedRows)
      this.selectedRows = selectedRowKeys
      this.imageUrls = selectedRows.map(item => item.voucherUrl)
    },
    //批量下载
    batchDownload() {
      for (let i = 0; i < this.imageUrls.length; i++) {
        setTimeout(() => {
          let a = document.createElement('a');
          a.setAttribute('download', '');
          a.href = this.imageUrls[i];
          document.body.appendChild(a);
          a.click();
        }, i * 1000);
      }
    },
    //批量预览
    handlePreview() {
      if (this.previewBtnText == "取消预览") {
        this.previewBtnText = '批量预览'
        this.batchPreviewViewerShow = false
      } else {
        this.previewBtnText = '取消预览'
        this.batchPreviewViewerShow = true
      }
    },
     //批量删除
     batchDelete(){
      let urlList = []
      let applyVoucherListNew = [] 
      let applyVoucherList = this.applyVoucherList
      for (let i=0;i<this.imageUrls.length;i++){
        applyVoucherListNew = applyVoucherList.filter(item => item.voucherUrl !== this.imageUrls[i])
        applyVoucherList = applyVoucherListNew
      }
      urlList = applyVoucherListNew.map(item => item.voucherUrl)
      this.deleteImgUpdateInfo.applyVoucherUrl = urlList.join(',')
      let _this = this
      this.$confirm({
        title: "操作提示",
        content: "是否删除该凭证信息？",
        okText: "确定",
        cancelText: "取消",
        async onOk() {
          await driverbookUpdate("", _this.deleteImgUpdateInfo).then((res) => {
            if (res.code == "0000") {
              _this.$message.success("删除凭证成功");
              _this.selectedRows = [],
              _this.pagination2.total = applyVoucherListNew.length;
              _this.search(_this.pagination.current);
              if (urlList.length > 0) {
                _this.applyVoucherList = applyVoucherListNew
                _this.initImageUrls = urlList
                _this.downLoadShow = false
              } else {
                _this.applyVoucherList = []
                _this.applyVoucherUrlVisible = false
              }

            } else {
              _this.$message.warn("删除凭证失败");
            }
          });
        },
      });
    },
    handleDeleteImg(record) {
      let urlList = []
      let applyVoucherListNew = []
      for (let i = 0; i < this.applyVoucherList.length; i++) {
        let item = this.applyVoucherList[i]
        if (item.voucherName !== record.voucherName) {
          urlList.push(item.voucherUrl)
          applyVoucherListNew.push(item)
        }
      }

      this.deleteImgUpdateInfo.applyVoucherUrl = urlList.join(',')
      let _this = this
      this.$confirm({
        title: "操作提示",
        content: "是否删除该凭证信息？",
        okText: "确定",
        cancelText: "取消",
        async onOk() {
          await driverbookUpdate("", _this.deleteImgUpdateInfo).then((res) => {
            if (res.code == "0000") {
              _this.$message.success("删除凭证成功");
              _this.selectedRows = [],
              _this.pagination2.total = applyVoucherListNew.length;
              _this.search(_this.pagination.current);
              if (urlList.length > 0) {
                _this.applyVoucherList = applyVoucherListNew
                _this.initImageUrls = urlList
              } else {
                _this.applyVoucherList = []
                _this.applyVoucherUrlVisible = false
              }

            } else {
              _this.$message.warn("删除凭证失败");
            }
          });
        },
      });

      console.log("删除后的imageList", this.deleteImgUpdateInfo)


    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-calendar-picker {
  width: 100%;
}

.space {
  display: inline-block;
  margin: 0 5px;
}

.add {
  text-align: left;
  margin-bottom: 10px;
}

.modelItem {
  /deep/ .ant-form-item {
    width: 50%;
    display: inline-block;

    /deep/ .ant-form-item-control {
      width: 200%;
    }
  }
}

.popRadio {
  /deep/.ant-radio-group {
    display: flex !important;
    margin-top: 10px;
  }
}

.voucher {
  /deep/ .ant-btn-primary {
    display: none !important;
  }
}

.imgs {
  width: 100px;
  height: 100px;
  margin-left: 50px;
}


.imgs:hover {
  cursor: pointer;
}

.download-btn,.delete-btn {
  background-color: #40a9ff;
  color: #fff;
  height: 40px;
  position: absolute;
  left: 10px;
  top: 25px;
}
.delete-btn{
  left: 130px;
}
.preview-box,
.init-preview-box {
  height: 60px;
  position: absolute;
  left: 250px;
  top: 15px;
  display: flex;

  align-items: center;

  .preview-btn {
    height: 40px;
    color: #fff;
    background-color: palevioletred;
  }

  .imgs-batch-preview {
    height: 60px;
    width: 500px;
    overflow: hidden;
    overflow-x: auto;
    white-space: nowrap;

    img {
      width: 60px;
      height: 100%;
      margin-left: 10px;
    }

    img:hover {
      cursor: pointer;
    }
  }

}

.init-preview-box {
  left: 15px;
}

.imgs-batch-preview::-webkit-scrollbar {
  height: 5px;
}

.imgs-batch-preview::-webkit-scrollbar-track {
  background-color: rgb(100, 169, 209);
  -webkit-border-radius: 0px;
  -moz-border-radius: 0px;
  border-radius: 0px;
}

.imgs-batch-preview::-webkit-scrollbar-thumb {
  background-color: palevioletred;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}</style>